<template>
  <div class="carousel-container" :style="{cursor: arrowVisible ? 'pointer' : ''}">
    <Arrow :style="arrowStyles" v-if="!isMobile"/>
    <div class="carousel-inner" 
      @click.prevent="handleClick" 
      @mousemove.passive="handleMousemove" 
      @mouseenter.passive="handleMouseenter" 
      @mouseleave.passive="handleMouseleave" 
      :style="aspectStyle"
    >
      <!-- <transition name="fade"> -->
          <div class="image-container">
            <!-- <LoadImage 
              v-for="index in num_images" 
              :key="index" 
              :src="imageSrc(index)" 
              :width="300"
              :height="200"
            /> -->
          <transition name="fade-swap">
            <div 
              class="image"
              :key="requiredImages[imageIndex]"
              :style="{backgroundImage: `url(${requiredImages[imageIndex]})`}"
              :width="600"
              :height="400"
            />
          </transition>
          <div v-if="shouldPreload" class="image-preload">
            <img 
              v-for="image in requiredImages" 
              :src="image" 
              :key="image"
            />
          </div>
        </div>
      <!-- </transition> -->
    </div>
    <div class="buttons-container text-subtitle-second" v-if="!isMobile">
      <span class="num-images">{{imageIndex+1}}<strong style='font-weight: 600; margin: 0 0.3em'>/</strong>{{num_images}}</span>
    </div>
  </div>
</template>

<script>
import Arrow from './Arrow'; 
import { throttle } from 'lodash'; 

export default {
  name: 'ImageCarousel',
  props: {
    images: Array,
    isMobile: Boolean, 
    aspect: {
      type: Number, 
      default: 9/16,
    },  
  },
  components: {
    Arrow,
  },
  data() {
    return {
      shouldPreload: window.innerWidth > 768, 
      imageIndex: 0,
      mousePos: {x: -10, y: -10}, 
      arrowVisible: false, 
      arrowPointingWest: false, 
      requiredImages: this.images.map(image => require(`../assets${image.src}`)),
    }
  },
  computed: {
    aspectStyle() {
      return {
        paddingBottom: `calc(${9/16} * 100%)`
      }
    },
    arrowStyles() {
      return {
        transform: `
          translate(${this.mousePos.x}px, ${this.mousePos.y}px) 
          rotate(${this.arrowPointingWest ? 180 : 0}deg)
        `, 
        opacity: this.arrowVisible ? 1 : 0,
      }
    },
    num_images() {
      return this.images && this.images.length || 1;
    },
  },
  methods: {
    handleMousemove: throttle(function(e) {
      this.arrowPointingWest = this.cursorIsOnLeft(e);
    }, 50),
    handleMouseenter: function(e) {
      if(this.num_images > 1) {
        this.arrowVisible = true;
      }
    },
    handleMouseleave: function(e) {
      this.arrowVisible = false;
    },
    handleClick: throttle(function(e) {
      if(this.cursorIsOnLeft(e)) {
        this.prevImage(e); 
      } else {
        this.nextImage(e)
      }
    }, 300),
    cursorIsOnLeft(e) {
      const carouselRect = this.$el.getBoundingClientRect();
      const isLeft = e.clientX < (carouselRect.left + carouselRect.width / 2);
      this.mousePos = {x: e.clientX - carouselRect.left, y: e.clientY - carouselRect.top};
      return isLeft; 
    },
    nextImage(e) {
      e.preventDefault();
      if(this.imageIndex < this.num_images - 1) {
        this.imageIndex += 1; 
      } else {
        this.imageIndex = 0;
      }
    },
    prevImage(e) {
      e.preventDefault();
      if(this.imageIndex <= 1) {
        this.imageIndex = this.num_images - 1;
      } else {
        this.imageIndex -= 1; 
      }
    },
  },
  mounted() {
    this.$emit("on-mount");
  }
}
</script>

<style lang="sass" scoped>
@import '../assets/partials/vars'

.carousel-container 
  display: block
  width: 100%
  position: relative

  .svg-arrow
    +flex-center
    position: absolute
    top: -50px
    left: -50px
    width: 100px
    height: 100px
    pointer-events: none
    overflow: visible
    transition: 111ms ease
    transition-property: transform opacity
    z-index: 10

  .carousel-inner
    height: 0
    overflow: hidden
    margin-bottom: 1rem
    position: relative

    .image-container
      position: absolute
      display: block
      top: 0
      left: 0
      width: 100%
      height: 100%
      transition: opacity 333ms ease 
      background: $primary-color
      .image
        // background-size: cover
        background-size: contain
        background-position: center
        background-repeat: no-repeat
        margin: auto
        height: 100%
        width: 100%

  .buttons-container
    position: inherit
    width: unset
    display: block
    float: right
   
    .num-images
      display: inline
      width: 100%
      height: 10px
      padding-top: 10px

@media only screen and (min-width: 768px)  
  .carousel-container 
    .buttons-container
      position: inherit
      width: unset
      display: block
      float: right

// Fade swap
.fade-swap-enter-active, .fade-swap-leave-active
  transition: opacity 0.3s ease

.fade-swap-enter, .fade-swap-leave   
  opacity: 0

</style>
